import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { ConfirmationDialog, type ConfirmationDialogProps } from './ConfirmationDialog';

export const DeleteConfirmationDialog = <T extends object>(props: ConfirmationDialogProps<T>) => {
    const { t } = useTranslation('common');

    return (
        <ConfirmationDialog
            confirmLabel={t('delete')}
            {...props}
            confirmButtonProps={{
                color: 'error'
            }}
        />
    );
};
